import { Redirect, Route } from "react-router-dom";

import PrivateRoute from "./components/PrivateRoute";
import Alerts from "./views/Alerts";
import Bookmark from "./views/Bookmark";
import Edit from "./views/Edit";
import Home from "./views/Home";
import Post from "./views/Post";
import Profile from "./views/Profile";
import Settings from "./views/Settings";
// import Signin from "./views/Signin";
// import Signup from "./views/Signup";
// import Chats from "./views/Chats";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SocketProvider, useSocketSubscribers } from "./api/useSocket";
import { getCurrentProfile } from "./redux/actions/currentProfileActions";
import AI from "./views/AI";
import Chats from "./views/Chats/Chats";
import Exams from "./views/Exams";
import Friends from "./views/Friends";
import Hashtag from "./views/Hashtag";
import Market from "./views/Market";
import NewPost from "./views/NewPost";
import Privacy from "./views/Privacy";
import Ride from "./views/Ride";
import Search from "./views/Search";
import Students from "./views/Students";
import Support from "./views/Support";
import Terms from "./views/Terms";
import Trending from "./views/Trending";
import Videos from "./views/videos";
import VideoGenerator from "./views/VideoGenerator";
import Reports from "./views/Reports";
// import './i18n';
// import LanguageToggle from "./components/LanguageToggle";
import { Toaster } from "react-hot-toast";
// import ShareHandler from './components/ShareHandler';
import {
  IonApp,
  IonContent,
  IonHeader,
  IonIcon,
  IonMenu,
  IonPage,
  IonRouterLink,
  IonRouterOutlet,
  IonSplitPane,
  IonTabs,
  IonToolbar,
  setupIonicReact,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import LoonLock from "./views/LoonLock";
import LoonAI from "./views/LoonAI";
import MarketItemDetail from "./views/MarketItemDetail";
import ResetPassword from "./views/ResetPassword";
import Travel from "./views/Travel";
import CSAESafety from "./views/csae-safety";
/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/core.css";
import "./assets/styles/style.css";
import "./assets/styles/variables.css";

import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import {
  chatbubbleEllipsesOutline,
  playCircleOutline,
  playOutline,
  notificationsOutline,
  helpCircleOutline,
  helpOutline,
} from "ionicons/icons";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import MobileFooter from "./components/layout/MobileFooter";
import SidebarLeft from "./components/layout/SidebarLeft";
import SidebarRight from "./components/layout/SidebarRight";
import BlockPopup from "./components/modal/BlockPopup";
import FriendActionModal from "./components/modal/FriendActionModal";
import PostModal from "./components/modal/PostModal";
import ReportPopup from "./components/modal/ReportPopup";
import {
  togglePostEditorModal,
  toggleSidebarModal,
} from "./redux/slicers/modalSlicer";
import Chat from "./views/Chat/Chat";
import ForgotPassword from "./views/ForgotPassword";
import MorePage from "./views/More";
import StudyPage from "./views/Study";
// import Performance from "./views/Performance";
// import PerformanceNoCDN from "./views/PerformanceNoCDN";
import { DEFAULT_HOME_PATH } from "./utils/constents";
import { getUnreadCounts } from "./redux/actions/chatActions";
import Badge from "./ui-components/Badge";
import { Link } from "react-router-dom";
import { bookmarkOutline } from "ionicons/icons";
import LoonMail from "./views/LoonMail";

import { Helmet } from "react-helmet-async";
import Blog from "./blog/Blog";
import BlogPost from "./blog/BlogPost";
import CommunityFAQ from "./views/CommunityFAQ/CommunityFAQ";
import Landing from "./views/Slides/Landing";
import Article from "./blog/Article";
import Signin2 from "./views/Auth/Signin2";
import Signup2 from "./views/Auth/Signup2";
import Onboarding from "./views/Onboarding/Onboarding";
import Verification from "./views/Auth/Verification";
import { useHeaderTitle } from "./components/layout/Header";
import GetHelp from "./views/GetHelp/GetHelp";
import HelpRequests from "./views/HelpRequests/AdminHelpRequests";
import FlaggedUsers from "./views/FlaggedUsers/FlaggedUsers";
// import Slides from "./views/Slides/Slides";

setupIonicReact();
const VideoIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="25px"
    viewBox="0 -960 960 960"
    width="25px"
    fill="#333333"
    className="app__video-icon"
  >
    <path d="m380-340 280-180-280-180v360Zm-60 220v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200H640v80H320ZM160-280h640v-480H160v480Zm0 0v-480 480Z" />
  </svg>
);
export const useIsDesktop = (breakpoint = 992) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= breakpoint);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isDesktop;
};

const MainRoutes = () => {
  const isDesktop = useIsDesktop();
  const dispatch = useDispatch();
  const { unread } = useSelector((state) => state.chat);
  const location = useLocation();
  const headerTitle = useHeaderTitle();

  const { data, loading } = useSelector((state) => state.currentProfile);
  const unreadAlertsCount =
    data?.notifications?.filter((n) => !n.read).length || 0;

  // Hide mobile header and footer chrome on single chat view (/messages/:id)
  // Matches paths like /messages/123 or /messages/abc-def (but not /messages itself)
  const hideNavChrome = /^\/messages\/[^/]+$/.test(location.pathname);
  const isVideosPage = location.pathname.startsWith("/videos");
  const isLoonAIPage = location.pathname.startsWith("/loon-ai");

  useSocketSubscribers();

  useEffect(() => {
    dispatch(getUnreadCounts());
  }, [dispatch]);

  const { sidebarModal, postEditorModal } = useSelector((state) => state.modal);
  const handleClick = () => {
    if (sidebarModal) dispatch(toggleSidebarModal());
    else if (postEditorModal) dispatch(togglePostEditorModal());
    else return;
  };

  const routes = (
    <IonRouterOutlet id="main">
      <Route exact path="/trending" component={Trending} />
      <Route exact path="/requests" component={HelpRequests} />
      <Route exact path="/get-help" component={GetHelp} />
      <Route exact path="/community-faq" component={CommunityFAQ} />
      <Route exact path="/hashtag/:tag" component={Hashtag} />
      <Route exact path="/alerts" component={Alerts} />
      <Route exact path="/messages" component={Chats} />
      <Route exact path="/messages/:id" component={Chat} />
      <Route exact path="/bookmarks" component={Bookmark} />
      <Route exact path="/friends" component={Friends} />
      <Route exact path="/new-post" component={NewPost} />
      <Route exact path="/post/:id" component={Post} />
      <Route exact path="/profile/:username" component={Profile} />
      <Route exact path="/edit" component={Edit} />

      <Route exact path="/more" component={MorePage} />
      {/* Videos */}
      <Route exact path="/videos" component={Videos} />
      {/* Uses tabs component */}
      <Route path="/home" component={Home} />
      <Route path="/study" component={StudyPage} />

      {/* Uses iframe */}
      <Route exact path="/exams" component={Exams} />
      <Route exact path="/students" component={Students} />
      <Route exact path="/ride" component={Ride} />
      <Route exact path="/market" component={Market} />
      <Route path="/market/item/:id" component={MarketItemDetail} />
      <Route exact path="/loonlock" component={LoonLock} />
      <Route exact path="/travel" component={Travel} />
      <Route exact path="/email" component={LoonMail} />

      {/* Not used */}
      <Route exact path="/settings" component={Settings} />
      <Route exact path="/search" component={Search} />
      {/* <Route exact path="/loon-ai" component={LoonAI} /> */}
      <Route exact path="/ai" component={AI} />
      <Route path="/reports" component={Reports} />
      <Route path="/flagged-users" component={FlaggedUsers} />
      <Route exact path="/private/llg-7r0xw-b29" component={VideoGenerator} />
      {/* <Route exact path="/about" component={() => <Article id="about" />} />
      <Route
        exact
        path="/terms-of-service"
        component={() => <Article id="terms-of-service" />}
      />
      <Route
        exact
        path="/privacy-policy"
        component={() => <Article id="privacy-policy" />}
      />
      <Route
        exact
        path="/contact-us"
        component={() => <Article id="contact-us" />}
      />
      <Route exact path="/faq" component={() => <Article id="faq" />} />
      <Route
        exact
        path="/child-safety-policy"
        component={() => <Article id="child-safety-policy" />}
      /> */}
      <Route exact path="/about" component={() => <Article id="about" />} />
      <Route exact path="/blog/:id" component={BlogPost} />
      <Route exact path="/blog" component={Blog} />
      <Route exact path="/onboarding" component={Onboarding} />
      <Route
        exact
        path="/"
        render={() => <Redirect to={DEFAULT_HOME_PATH} />}
      />
    </IonRouterOutlet>
  );

  return (
    <div onClick={handleClick}>
      {isDesktop && !isVideosPage ? (
        <IonSplitPane contentId="main">
          <IonMenu contentId="main" side="start">
            <IonContent className="ion-padding">
              <SidebarLeft />
            </IonContent>
          </IonMenu>
          {!isLoonAIPage && (
            <IonMenu contentId="main" side="end">
              <IonContent className="ion-padding">
                <SidebarRight />
              </IonContent>
            </IonMenu>
          )}
          {routes}
        </IonSplitPane>
      ) : (
        <IonTabs>
          {!hideNavChrome && !isVideosPage && (
            <IonHeader slot="top" className="top-header" mode="ios">
              <IonToolbar>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    padding: "0 0.5rem",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <Link
                      to={DEFAULT_HOME_PATH}
                      className="logo-font"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        // color: "#374151",
                        gap: "5px",
                      }}
                    >
                      <img
                        src="/logo4.png"
                        alt="loonlog"
                        height={36}
                        style={{ marginTop: "5px" }}
                      />
                      <span
                        className="poetsen"
                        style={{
                          fontSize: "1.2rem",
                          paddingTop: "3px",
                          color: "#969696",
                        }}
                      >
                        {headerTitle}
                      </span>
                    </Link>
                    {/*
                     <Link to="/videos">
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      > */}
                    {/* <IonIcon
                          icon={playCircleOutline}
                          style={{ fontSize: "30px", color: "#000000" }}
                        /> */}
                    {/* <VideoIcon />
                      </div>
                    </Link> */}
                  </div>
                  <div
                    style={{
                      flex: "1",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* <Link to={DEFAULT_HOME_PATH} className="logo-font">
                      <img
                        src="/logo4.png"
                        alt="loonlog"
                        height={36}
                        style={{ marginTop: "5px" }}
                      />
                    </Link> */}
                  </div>
                  <div
                    style={{
                      flex: "1",
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "8px",
                    }}
                  >
                    <IonRouterLink routerLink="/get-help">
                      <div
                        style={{
                          // width: "36px",
                          height: "36px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingRight: 0,
                        }}
                      >
                        <IonIcon
                          icon={helpCircleOutline}
                          style={{ fontSize: "24px", color: "black" }}
                        />
                      </div>
                    </IonRouterLink>
                    <Link to="/alerts">
                      <Badge content={unreadAlertsCount}>
                        <div
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <IonIcon
                            icon={notificationsOutline}
                            style={{ fontSize: "24px", color: "black" }}
                          />
                        </div>
                      </Badge>
                    </Link>
                    <Link to="/messages">
                      <Badge content={unread.total}>
                        <div
                          style={{
                            // width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingRight: 0,
                          }}
                        >
                          <IonIcon
                            icon={chatbubbleEllipsesOutline}
                            style={{ fontSize: "24px", color: "black" }}
                          />
                        </div>
                      </Badge>
                    </Link>
                  </div>
                </div>
              </IonToolbar>
            </IonHeader>
          )}
          {routes}
          {!hideNavChrome && <MobileFooter isVideosPage={isVideosPage} />}
        </IonTabs>
      )}
    </div>
  );
};

const MainAppContent = () => {
  const { data, loading } = useSelector((state) => state.currentProfile);
  const location = useLocation();
  if (loading) {
    return (
      <>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <IonPage>
          <IonContent>
            <div>Loading...</div>
          </IonContent>
        </IonPage>
      </>
    );
  }

  if (!data) {
    return <Redirect to="/signin" />;
  }

  // Check for onboarding
  const hasSeenOnboarding = localStorage.getItem(`onboarding_${data._id}`);

  if (data.status === "pending" && location.pathname !== "/verification") {
    return <Redirect to="/verification" />;
  }

  if (
    data.status === "active" &&
    !hasSeenOnboarding &&
    (!data.posts || data.posts.length === 0) &&
    location.pathname !== "/onboarding"
  ) {
    return <Redirect to="/onboarding" />;
  }

  return <MainRoutes />;
};

const RootRoute = () => {
  const { data, loading } = useSelector((state) => state.currentProfile);

  if (loading) {
    return (
      <IonPage>
        <IonContent>
          <div>Loading...</div>
        </IonContent>
      </IonPage>
    );
  }

  // If user is logged in, redirect to home page
  if (data) {
    return <Redirect to={DEFAULT_HOME_PATH} />;
  }

  // If user is not logged in, show slides
  return <Landing />;
};

const App = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCurrentProfile());
  }, [dispatch]);

  return (
    <SocketProvider>
      {/* <Router>
        <Switch> */}
      <IonApp>
        <IonReactRouter>
          {/* <PostFAB /> */}
          <PostModal />
          <FriendActionModal />
          <BlockPopup />
          <ReportPopup />
          <IonRouterOutlet>
            {/* Auth */}
            {/* <Route exact path="/signin" component={Signin} /> */}
            <Route exact path="/signin" component={Signin2} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route
              exact
              path="/reset-password/:token"
              component={ResetPassword}
            />
            {/* <Route exact path="/signup" component={Signup} /> */}
            <Route exact path="/signup" component={Signup2} />
            <Route exact path="/verification" component={Verification} />
            {/* Static */}
            {/* <Route exact path="/support" component={Support} /> */}
            {/* <Route exact path="/privacy" component={Privacy} /> */}
            {/* <Route exact path="/terms" component={Terms} /> */}
            <Route
              exact
              path="/about"
              component={() => <Article id="about" />}
            />
            <Route
              exact
              path="/terms-of-service"
              component={() => <Article id="terms-of-service" />}
            />
            <Route
              exact
              path="/privacy-policy"
              component={() => <Article id="privacy-policy" />}
            />
            <Route
              exact
              path="/contact-us"
              component={() => <Article id="contact-us" />}
            />
            <Route exact path="/faq" component={() => <Article id="faq" />} />
            <Route
              exact
              path="/child-safety-policy"
              component={() => <Article id="child-safety-policy" />}
            />
            <Route
              exact
              path="/about"
              component={() => <Article id="about" />}
            />
            <Route exact path="/blog" component={Blog} />
            <Route exact path="/blog/:id" component={BlogPost} />
            <Route exact path="/" component={RootRoute} />
            {/* <Route exact path="/landing" component={Landing} /> */}
            {/* <Route exact path="/about" component={About} /> */}
            {/* <Route exact path="/csae-safety" component={CSAESafety} /> */}
            {/* Core */}
            <Route render={() => <MainAppContent />} />
          </IonRouterOutlet>
          <Toaster />
        </IonReactRouter>
      </IonApp>
    </SocketProvider>
  );
};

export default App;
